import {
    default as accordionSupport,
    useDefaultPDPTabSetStates,
    setInitialStateForTabSet,
    mergeTabSetState,
    bindAccordionChangeEvent
} from '../../../core/js/uiSupport/accordion';

import { mDom } from '../../../core/js/utils/renderUtils';
import template from 'product-details.j2';

import { generate, templateLocationExists } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import { onStateChange } from '../utils/productComponentUtils';

import { init as productShippingDetailsInit } from "./productShippingDetailsComponent";
import { init as productStoreAvailabilityInit } from './productStoreAvailabilityComponent';

import { pushModalTransition } from '../../../core/js/actions/modalActions';
import { init as requestSwatchModalInit } from './productRequestSwatchModalComponent';

import { fireProductDetailsUtagEvent } from '../utils/productDetailsUtils';
import {
    setSelectedProductForRequestSwatch
} from '../actions/productActions';

const allStatesCollapsed = (tabSet, aStore) => 'collapse';

function firstRender(store) {
    if (this.forFamilyProduct || store.getState().quickshop.collapseAccordions) {
        accordionSupport(this, this.templateLocation, allStatesCollapsed);
    } else {
        accordionSupport(this, this.templateLocation, useDefaultPDPTabSetStates);
    }
    setInitialStateForTabSet.call(this);
}

function getFamilyProductForIndex(store, index) {
    return store.getState().product.familyProducts[index];
}

function getSelectedProductForRequestSwatch(store, e) {
    // Account for if a family product has a request swatch link
    if ($(e.target).parents('.dom-family-product').length > 0) {
        const familyProductIndex = $(e.target).parents('.dom-family-product').attr('data-index');

        return getFamilyProductForIndex(store, familyProductIndex);
    }
    return store.getState().product;
}

/**
 * Attach component events to DOM
 * @param {object} store The store
 * @returns {undefined}
 */
function attachEvents(store) {
    $(document).on('click', '.js-request-swatch-cta', (e) => {
        e.preventDefault();
        const selectedProduct = getSelectedProductForRequestSwatch(store, e);

        store.dispatch(setSelectedProductForRequestSwatch(selectedProduct.product, selectedProduct.productControls));
        const payload = pushModalTransition(requestSwatchModalInit, {}, e, self.name);

        $.event.trigger({
            type: payload.type,
            payload: payload
        });
    });

    $(document).on('click', `${this.templateLocation} .js-accordion-tab`, (e) => {
        const tab = $(e.target);
        fireProductDetailsUtagEvent(store, tab);
    });

    bindAccordionChangeEvent.bind(this)();
}

function afterRender(store) {
    if (this.forFamilyProduct) {
        accordionSupport(this, this.templateLocation, allStatesCollapsed);
    } else {
        accordionSupport(this, this.templateLocation, useDefaultPDPTabSetStates);
    }
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .js-product-details',
        attachEvents: attachEvents,
        onStateChange: onStateChange,
        beforeInsertion: mergeTabSetState,
        children: [
            [productShippingDetailsInit],
            [productStoreAvailabilityInit]
        ],
        jsAccordionClass: '.js-accordion-tabset',
        accordionNameDataAttr: 'data-accordion-tab-name',
        accordionState: {},
        template: template,
        name: 'productDetailsComponent',
        watch: 'product.productDetails',
        forFamilyProduct: false,
        replace: false,
        firstRender: firstRender,
        afterRender: afterRender,
        renderType: mDom,
        isComponentValid: templateLocationExists
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
